module.exports = __webpack_public_path__ + "static/logo-09e34c38a53ff532ecbffb6c15ab9187.png";